import React from "react";

import { Link } from "react-router-dom";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";

import LogoutPage from './Logout';
/// Image
import profile from "../../../images/profile/2.png";
import avatar from "../../../images/avatar/2.jpg";
import { Dropdown } from "react-bootstrap";
import { fromUnixTime } from "date-fns";
import { BsSunriseFill, BsFillMoonFill } from "react-icons/bs"
import { useState } from "react";

import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from "react";
import { zIndex } from "material-ui/styles";
import ChangePassword from "./ChangePassword";
import Profile from "./Profile";
import { OneclearUpdategetRanDashboard } from "../../../store/actions/createTicketManageFields";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Header = ({ onNote, toggle, onProfile, onNotification, onClick }) => {
	const [nightDayTheme, setTheme] = useState('')

	const dispatch=useDispatch()
	const history = useHistory()


	const [notificationData, setnotificationData] = useState([{
		"title":"abcd",
		"modulename":"abcd",
		"description":"abcd"
	},{
		"title":"abcd",
		"modulename":"abcd",
		"description":"abcd"
	},{
		"title":"abcd",
		"modulename":"abcd",
		"description":"abcd"
	},{
		"title":"abcd",
		"modulename":"abcd",
		"description":"abcd"
	}])


	let notification =useSelector((state)=>{
        let val=state.CommonResponse.notificationList
        console.log("the loader state=",val)
        return {val}
    })

	
	const setLocalStorageHandler = () => {
		const color = localStorage.getItem("color")
		console.log(color, "color ")
		if (color != null) {
			if (color == 'dark') {
				localStorage.setItem("color", "light")
				setTheme("light")
				setThemeHandler(2)
				window.location.reload()
			}
			else if (color && color == 'light') {
				localStorage.setItem('color', "light")
				setThemeHandler(2)
				setTheme("light")
				window.location.reload()
			}
		}
		else {

			setThemeHandler(2)
			localStorage.setItem('color', "light")
			setTheme("light")
		}
	}

	const setThemeHandler = (no) => {
		console.log("colorCode", "colorCode is ", no)
		localStorage.setItem("colorCode", JSON.stringify(no))
		window.location.reload()
	}

	const liclicker = (id,url) => {

		dispatch(OneclearUpdategetRanDashboard(id))
		history.push(url)
		// window.location.reload()
	}

	var path = window.location.pathname.split("/");
	var fullpath = window.location.pathname;

	var name = path[path.length - 1].split("-");
	var userDetails = JSON.parse(localStorage.getItem('userDetails'))	
	var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;

	console.log("filterName", fullpath, path, filterName, "filterName")

	var newHeader = {
		"/PAG/Mop/database": "MOP Dashboard",
		"/PAG/network/database": "Project Database",
		"/PAG/ProjectList": "Project List",
		"/PAG/ran/support/dashboard": "RAN Support Dashboard",
		"/PAG/ran/support/tracker": "RAN Support Tracker",
		"/PAG/ran/support/dailyReport": "RAN Support Daily Activity",
		"/PAG/ix/support/dailyReport": "IX Support Daily Activity",
		"/PAG/E911/dashboard": "E911 Dashboard",
		"/PAG/E911/Tracker": "E911 Tracker",
		"/PAG/E911CallTest/form": "E911 Form",
		"/PAG/trobleTicke/form": "Trouble Ticket Form",
		"/PAG/troubleTickets/dashboard": "Trouble Ticket Dashboard",
		"/PAG/troubleTickets/tracker": "Trouble Ticket Tracker",
		"/PAG/troubleTickets/dashboard": "Trouble Ticket Dashboard",
		"/PAG/ix/module": "IX Scheduler",
		"/PAG/ix/calender": "IX Calendar",
		"/PAG/ix/dashboard": "IX Dashboard",
		"/PAG/rtt/dashboard": "RTT Dashboard",
		"/PAG/rtt/form": "RTT Form",
		"/PAG/72alarm/tracker": "48 Alarm Tracker",
		"/PAG/72alarm/dashboard": "48 Hours Alarm Dashboard",
		"/PAG/48alarm/dashboard": "48 Hours Alarm Dashboard",
		
		"/PAG/sevenTwo/form": "48 Alarm Form",
		"/PAG/fourEight/form": "48 Alarm Form",
		"/PAG/customer/dashboard": "Customer Support Dashboard",
		"/PAG/vendor/dashboard": "Vendor Dashboard",
		"/PAG/aws/dashboard": "AWS Dashboard",
		"/PAG/ran/sla/report": "SLA Report",
		"/PAG/ix/sla/report": "SLA Report",
		"/PAG/ran/nestingTime/report": "Nesting Report",
		"/PAG/ran/nestingTime/tracker": "Nesting Tracker",
		"/PAG/RanSupportticket": "On The Fly",
		"/PAG/ran/executivespillover/report": "Executive Spillover Report",
		"/PAG/ix/executivespillover/report": "Executive Spillover Report",

		"/networkDatabase": "Network Database",
		"/inflight": "Inflight Database",
		"/magenta": "Magenta Database",
		// "/PAG/ran/sla/report":"Nesting Tracker",
		"/inflight": "Inflight Database",
		"/magenta": "Magenta Database",
		"/networkDatabase": "Network Database",
		"/networkDatabase": "Network Database",
		"/PAG/launchSSSNNP/dashboard": 'launch SSS NNP',
		"/PAG/ssv/dashboard": 'SSV Dashboard',
		"/PAG/ssv/Approval/dashboard": 'SSV Approval',
		"/PAG/launchSSSNNP/Approval/dashboard": 'SSS Approval',
		"/PAG/merged/Approval/dashboard": 'SSV & SSS Approval',
		"/PAG/combine/Approval/dashboard": 'SSV & SSS Approval',
		"/PAG/ssv/add": 'SSV Form',
		"/PAG/manage/account": 'Manage Account',
		"/PAG/manage/market": 'Manage Market',
		"/PAG/userAccount": 'Manage User',
		"/PAG/manage/vendor": 'Manage Vendor',
		"/PAG/userCrew": 'Manage Crew',
		"/PAG/manage/crewcompany": 'Manage Crews Company',
		"/PAG/manage/technology": 'Manage Technology',
		"/PAG/manage/dropDown": 'Manage Dropdown',

		"/PAG/T-Mobile": 'Deployment Managers',
		"/PAG/manageEngineer": 'Manage Engineers',
		"/PAG/userAccount": 'Manage User',
		"/PAG/vendorScoreCard/dashboard":"Vendor Score Card Dashboard",
		"/PAG/ix/module/FLogin": "IX – FE Login",
		"/PAG/ix/module/FLogout": "IX – FE Logout",
		"/PAG/ix/module/ILogin": "Integration Login",
		"/PAG/ix/module/ILogout": "Integration Logout",
		"/PAG/manage/scoreCard":"Manage Vendor Score Card",
		"/PAG/vendorScore/dashboard":"Vendor Score Card",
	}
	let newFullPath = fullpath.split("/").slice(0, 4)
	let fiveArray = fullpath.split("/").slice(0, 5)
	console.log(fullpath.split("/"), newFullPath, "newFullPathnewFullPath")
	console.log(fullpath, "newHeaderfullpath")
	var finalName = filterName.includes("app")
		? filterName.filter((f) => f !== "app")
		: filterName.includes("ui")
			? filterName.filter((f) => f !== "ui")
			: filterName.includes("uc")
				? filterName.filter((f) => f !== "uc")
				: filterName.includes("basic")
					? filterName.filter((f) => f !== "basic")
					: filterName.includes("jquery")
						? filterName.filter((f) => f !== "jquery")
						: filterName.includes("table")
							? filterName.filter((f) => f !== "table")
							: filterName.includes("page")
								? filterName.filter((f) => f !== "page")
								: filterName.includes("email")
									? filterName.filter((f) => f !== "email")
									: filterName.includes("ecom")
										? filterName.filter((f) => f !== "ecom")
										: filterName.includes("chart")
											? filterName.filter((f) => f !== "chart")
											: filterName.includes("editor")
												? filterName.filter((f) => f !== "editor")
												: filterName;
	console.log("nivfdbgdgf", nightDayTheme)
	return (





		<div style={{ height: "50px", zIndex: 400 }} className="header">
			<div style={{ height: "50px" }} className="header-content ">
				<nav style={{ height: "50px" }} className="navbar navbar-expand" >
					<div style={{ height: "50px" }} className="collapse navbar-collapse justify-content-between">
						<div style={{ height: "50px" }} className="header-left">
							{/* <div
							className="dashboard_bar"
							style={{ textTransform: "capitalize" }}
						  >
							{finalName.join(" ").length === 0
							  ? "Dashboard"
							  : finalName.join(" ")}
						</div> */}

							<div
								className="dashboard_bar"
								style={{ textTransform: "capitalize" }}
							>
								{newHeader[fullpath] ? newHeader[fullpath] : newHeader[fiveArray.join("/")] ? newHeader[fiveArray.join("/")] : newHeader[newFullPath.join("/")]}
								{console.log(newHeader[fullpath], fullpath, newFullPath.join("/"), fiveArray.join("/"), "newHeaderfullpath")}
							</div>
						</div>
						<ul style={{ height: "50px" }} className="navbar-nav header-right">
							<li className="nav-item">
								{/* <div className="input-group search-area ml-auto d-inline-flex">
								<input type="text" className="form-control" placeholder="Search here"  />
								<div className="input-group-append">
									<button type="button" className="input-group-text"><i className="flaticon-381-search-2"></i></button>
								</div>
							</div> */}
							</li>
							<li className="nav-item" onClick={setLocalStorageHandler}>
								{/* <Link to={"#"} className="btn btn-primary btn-xs  d-md-block d-none"> */}
								{/* <i class="fa-solid fa-sun"></i>
										 */}

								{/* {
										nightDayTheme=="light"?<span><BsSunriseFill/></span>:<span><BsFillMoonFill/></span>}
									</Link> */}
							</li>
							{/* <Dropdown as="li" className="nav-item btn-xs">
					
							<Dropdown.Toggle variant=""  className="nav-link   i-false btn-xs" >
							<i className="fa fa-cog scale5" aria-hidden="true"></i> */}
							{/* <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M21.75 14.8385V12.0463C21.7471 9.88552 20.9385 7.80353 19.4821 6.20735C18.0258 4.61116 16.0264 3.61555 13.875 3.41516V1.625C13.875 1.39294 13.7828 1.17038 13.6187 1.00628C13.4546 0.842187 13.2321 0.75 13 0.75C12.7679 0.75 12.5454 0.842187 12.3813 1.00628C12.2172 1.17038 12.125 1.39294 12.125 1.625V3.41534C9.97361 3.61572 7.97429 4.61131 6.51794 6.20746C5.06159 7.80361 4.25291 9.88555 4.25 12.0463V14.8383C3.26257 15.0412 2.37529 15.5784 1.73774 16.3593C1.10019 17.1401 0.751339 18.1169 0.75 19.125C0.750764 19.821 1.02757 20.4882 1.51969 20.9803C2.01181 21.4724 2.67904 21.7492 3.375 21.75H8.71346C8.91521 22.738 9.45205 23.6259 10.2331 24.2636C11.0142 24.9013 11.9916 25.2497 13 25.2497C14.0084 25.2497 14.9858 24.9013 15.7669 24.2636C16.548 23.6259 17.0848 22.738 17.2865 21.75H22.625C23.321 21.7492 23.9882 21.4724 24.4803 20.9803C24.9724 20.4882 25.2492 19.821 25.25 19.125C25.2486 18.117 24.8998 17.1402 24.2622 16.3594C23.6247 15.5786 22.7374 15.0414 21.75 14.8385ZM6 12.0463C6.00232 10.2113 6.73226 8.45223 8.02974 7.15474C9.32723 5.85726 11.0863 5.12732 12.9212 5.125H13.0788C14.9137 5.12732 16.6728 5.85726 17.9703 7.15474C19.2677 8.45223 19.9977 10.2113 20 12.0463V14.75H6V12.0463ZM13 23.5C12.4589 23.4983 11.9316 23.3292 11.4905 23.0159C11.0493 22.7026 10.716 22.2604 10.5363 21.75H15.4637C15.284 22.2604 14.9507 22.7026 14.5095 23.0159C14.0684 23.3292 13.5411 23.4983 13 23.5ZM22.625 20H3.375C3.14298 19.9999 2.9205 19.9076 2.75644 19.7436C2.59237 19.5795 2.50014 19.357 2.5 19.125C2.50076 18.429 2.77757 17.7618 3.26969 17.2697C3.76181 16.7776 4.42904 16.5008 5.125 16.5H20.875C21.571 16.5008 22.2382 16.7776 22.7303 17.2697C23.2224 17.7618 23.4992 18.429 23.5 19.125C23.4999 19.357 23.4076 19.5795 23.2436 19.7436C23.0795 19.9076 22.857 19.9999 22.625 20Z" fill="#13B499"/>
								</svg> */}
							{/* <div className="pulse-css"></div> */}
							{/* </Dropdown.Toggle> */}
							{/* <Dropdown.Menu align="right" className="mt-2">
							  <PerfectScrollbar className="widget-media dz-scroll p-3 height380 ps">
								<ul className="timeline">

								<li key={"color_1"} onClick={()=>setThemeHandler(1)}>
									<div className="timeline-panel">
									  <div className="media mr-2 color_2" style={{backgroundColor:'#03090f'}}>
										
									  </div>
									  
									</div>
								  </li>
								 
								  <li key="color_2" onClick={()=>setThemeHandler(2)}>
									<div className="timeline-panel">
									  <div className="media mr-2 color_2" style={{backgroundColor:"#143b64"}}>
										
									  </div>
									  
									</div>
								  </li>
								  <li key="color_3" onClick={()=>setThemeHandler(3)}>
									<div className="timeline-panel">
									  <div className="media mr-2 media-info " style={{backgroundColor:"#09584a"}}></div>
	
									</div>
								  </li>
								  <li key="color_4" onClick={()=>setThemeHandler(4)}>
									<div className="timeline-panel">
									  <div className="media mr-2" value='4'style={{backgroundColor:"#22134e"}}>
								
									  </div>
									 
									</div>
								  </li>
								  <li key="color_5" onClick={()=>setThemeHandler(5)}>
									<div className="timeline-panel">
									  <div className="media mr-2" value ='5' style={{backgroundColor:"#711717"}}>

									  </div>
									  
									</div>
								  </li>
								  <li key="color_6" onClick={()=>setThemeHandler(6)}>
									<div className="timeline-panel">
									  <div className="media mr-2 media-danger" value ='6' style={{backgroundColor:"#121843"}}></div>
			
									</div>
								  </li>
								  <li key="color_7" onClick={()=>setThemeHandler(7)}>
									<div className="timeline-panel">
									  <div className="media mr-2 media-primary" value ='7' style={{backgroundColor:"#3511d0"}}>
										
									  </div>
								
									</div>
								  </li>
								  <li key="color_8" onClick={()=>setThemeHandler(8)}>
									<div className="timeline-panel">
									  <div className="media mr-2 media-primary" value ='8' style={{backgroundColor:"#1161aa"}}>
										
									  </div>
									 
									</div>
								  </li>
								  <li key="color_9" onClick={()=>setThemeHandler(9)}>
									<div className="timeline-panel">
									  <div className="media mr-2 media-primary"  style={{backgroundColor:"#002629"}}>
										
									  </div>
									 
									</div>
								  </li>
								  <li key="color_10" onClick={()=>setThemeHandler(10)}>
									<div className="timeline-panel">
									  <div className="media mr-2 media-primary" value ='10' style={{backgroundColor:"#af5b00"}}>
										
									  </div>
									 
									</div>
								  </li>
								</ul>
								<div className="ps__rail-x" style={{ left: 0, bottom: 0 }}>
								  <div
									className="ps__thumb-x"
									tabIndex={0}
									style={{ left: 0, width: 0 }}
								  />
								</div>
								<div className="ps__rail-y" style={{ top: 0, right: 0 }}>
								  <div
									className="ps__thumb-y"
									tabIndex={0}
									style={{ top: 0, height: 0 }}
								  />
								</div>
							  </PerfectScrollbar>
							</Dropdown.Menu> */}
							{/* </Dropdown> */}

							<Dropdown as="li" className="nav-item  notification_dropdown">
								<Dropdown.Toggle variant="" className="nav-link  ai-icon i-false" >
									<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M21.75 14.8385V12.0463C21.7471 9.88552 20.9385 7.80353 19.4821 6.20735C18.0258 4.61116 16.0264 3.61555 13.875 3.41516V1.625C13.875 1.39294 13.7828 1.17038 13.6187 1.00628C13.4546 0.842187 13.2321 0.75 13 0.75C12.7679 0.75 12.5454 0.842187 12.3813 1.00628C12.2172 1.17038 12.125 1.39294 12.125 1.625V3.41534C9.97361 3.61572 7.97429 4.61131 6.51794 6.20746C5.06159 7.80361 4.25291 9.88555 4.25 12.0463V14.8383C3.26257 15.0412 2.37529 15.5784 1.73774 16.3593C1.10019 17.1401 0.751339 18.1169 0.75 19.125C0.750764 19.821 1.02757 20.4882 1.51969 20.9803C2.01181 21.4724 2.67904 21.7492 3.375 21.75H8.71346C8.91521 22.738 9.45205 23.6259 10.2331 24.2636C11.0142 24.9013 11.9916 25.2497 13 25.2497C14.0084 25.2497 14.9858 24.9013 15.7669 24.2636C16.548 23.6259 17.0848 22.738 17.2865 21.75H22.625C23.321 21.7492 23.9882 21.4724 24.4803 20.9803C24.9724 20.4882 25.2492 19.821 25.25 19.125C25.2486 18.117 24.8998 17.1402 24.2622 16.3594C23.6247 15.5786 22.7374 15.0414 21.75 14.8385ZM6 12.0463C6.00232 10.2113 6.73226 8.45223 8.02974 7.15474C9.32723 5.85726 11.0863 5.12732 12.9212 5.125H13.0788C14.9137 5.12732 16.6728 5.85726 17.9703 7.15474C19.2677 8.45223 19.9977 10.2113 20 12.0463V14.75H6V12.0463ZM13 23.5C12.4589 23.4983 11.9316 23.3292 11.4905 23.0159C11.0493 22.7026 10.716 22.2604 10.5363 21.75H15.4637C15.284 22.2604 14.9507 22.7026 14.5095 23.0159C14.0684 23.3292 13.5411 23.4983 13 23.5ZM22.625 20H3.375C3.14298 19.9999 2.9205 19.9076 2.75644 19.7436C2.59237 19.5795 2.50014 19.357 2.5 19.125C2.50076 18.429 2.77757 17.7618 3.26969 17.2697C3.76181 16.7776 4.42904 16.5008 5.125 16.5H20.875C21.571 16.5008 22.2382 16.7776 22.7303 17.2697C23.2224 17.7618 23.4992 18.429 23.5 19.125C23.4999 19.357 23.4076 19.5795 23.2436 19.7436C23.0795 19.9076 22.857 19.9999 22.625 20Z" fill="#13B499" />
									</svg>
									{notification?.val.length>0?<div className="pulse-css"></div>:""}
								</Dropdown.Toggle>
								<Dropdown.Menu align="right" className="mt-2">
									<PerfectScrollbar className="widget-media dz-scroll p-3 height380 ps">
										<ul className="timeline">


											{/* {notificationData.map((data) => [
												<li>
													<div className="timeline-panel">
														<div className="media mr-2">
															<img alt="avatar" width={50} src={avatar} />
														</div>
														<div className="media-body">
															<h6 className="mb-1">{data.title}</h6>
															<h6 className="mb-1">{data.modulename}</h6>
															<small className="d-block">
																{data.description}
															</small>
														</div>
													</div>
												</li>
											])}
											 */}
											 
											 {
											 notification?.val.length>0?
											 	notification?.val.map((data) => [
												<li onClick={()=>{liclicker(data.uniqueId,data.url)}}>
													<div className="timeline-panel">
														<div className="media mr-2">
															{/* <img alt="avatar" width={50} src={avatar} /> */}
														</div>
														<div className="media-body">
															<h6 className="mb-1">{data.title}</h6>
															<h6 className="mb-1">{data.modulename}</h6>
															<small className="d-block">
																{data.description}
															</small>
														</div>
													</div>
												</li>
												]):
												<li>
													<div className="timeline-panel">
														{/* <div className="media mr-2"> */}
															{/* <img alt="avatar" width={50} src={avatar} /> */}
														{/* </div> */}
														<div className="media-body">
															<h6 className="text-center mb-1">No Notification</h6>
														</div>
													</div>
												</li>}

											{/* <li>
												<div className="timeline-panel">
													<div className="media mr-2 media-info">KG</div>
													<div className="media-body">
														<h6 className="mb-1">
															Resport created successfully
														</h6>
														<small className="d-block">
															29 July 2020 - 02:26 PM
														</small>
													</div>
												</div>
											</li>
											<li>
												<div className="timeline-panel">
													<div className="media mr-2 media-success">
														<i className="fa fa-home" />
													</div>
													<div className="media-body">
														<h6 className="mb-1">Reminder : Treatment Time!</h6>
														<small className="d-block">
															29 July 2020 - 02:26 PM
														</small>
													</div>
												</div>
											</li>

											<li>
												<div className="timeline-panel">
													<div className="media mr-2">
														<img alt="avatar" width={50} src={avatar} />
													</div>
													<div className="media-body">
														<h6 className="mb-1">Dr sultads Send you Photo</h6>
														<small className="d-block">
															29 July 2020 - 02:26 PM
														</small>
													</div>
												</div>
											</li>
											<li>
												<div className="timeline-panel">
													<div className="media mr-2 media-info">KG</div>
													<div className="media-body">
														<h6 className="mb-1">
															Resport created successfully
														</h6>
														<small className="d-block">
															29 July 2020 - 02:26 PM
														</small>
													</div>
												</div>
											</li>
											<li>
												<div className="timeline-panel">
													<div className="media mr-2 media-success">
														<i className="fa fa-home" />
													</div>
													<div className="media-body">
														<h6 className="mb-1">Reminder : Treatment Time!</h6>
														<small className="d-block">
															29 July 2020 - 02:26 PM
														</small>
													</div>
												</div>
											</li><li>
												<div className="timeline-panel">
													<div className="media mr-2">
														<img alt="avatar" width={50} src={avatar} />
													</div>
													<div className="media-body">
														<h6 className="mb-1">Dr sultads Send you Photo</h6>
														<small className="d-block">
															29 July 2020 - 02:26 PM
														</small>
													</div>
												</div>
											</li>
											<li>
												<div className="timeline-panel">
													<div className="media mr-2 media-info">KG</div>
													<div className="media-body">
														<h6 className="mb-1">
															Resport created successfully
														</h6>
														<small className="d-block">
															29 July 2020 - 02:26 PM
														</small>
													</div>
												</div>
											</li>
											<li>
												<div className="timeline-panel">
													<div className="media mr-2 media-success">
														<i className="fa fa-home" />
													</div>
													<div className="media-body">
														<h6 className="mb-1">Reminder : Treatment Time!</h6>
														<small className="d-block">
															29 July 2020 - 02:26 PM
														</small>
													</div>
												</div>
											</li><li>
												<div className="timeline-panel">
													<div className="media mr-2">
														<img alt="avatar" width={50} src={avatar} />
													</div>
													<div className="media-body">
														<h6 className="mb-1">Dr sultads Send you Photo</h6>
														<small className="d-block">
															29 July 2020 - 02:26 PM
														</small>
													</div>
												</div>
											</li>
											<li>
												<div className="timeline-panel">
													<div className="media mr-2 media-info">KG</div>
													<div className="media-body">
														<h6 className="mb-1">
															Resport created successfully
														</h6>
														<small className="d-block">
															29 July 2020 - 02:26 PM
														</small>
													</div>
												</div>
											</li>
											<li>
												<div className="timeline-panel">
													<div className="media mr-2 media-success">
														<i className="fa fa-home" />
													</div>
													<div className="media-body">
														<h6 className="mb-1">Reminder : Treatment Time!</h6>
														<small className="d-block">
															29 July 2020 - 02:26 PM
														</small>
													</div>
												</div>
											</li>
											<li>
												<div className="timeline-panel">
													<div className="media mr-2">
														<img alt="avatar" width={50} src={avatar} />
													</div>
													<div className="media-body">
														<h6 className="mb-1">Dr sultads Send you Photo</h6>
														<small className="d-block">
															29 July 2020 - 02:26 PM
														</small>
													</div>
												</div>
											</li>
											<li>
												<div className="timeline-panel">
													<div className="media mr-2 media-danger">KG</div>
													<div className="media-body">
														<h6 className="mb-1">
															Resport created successfully
														</h6>
														<small className="d-block">
															29 July 2020 - 02:26 PM
														</small>
													</div>
												</div>
											</li>
											<li>
												<div className="timeline-panel">
													<div className="media mr-2 media-primary">
														<i className="fa fa-home" />
													</div>
													<div className="media-body">
														<h6 className="mb-1">Reminder : Treatment Time!</h6>
														<small className="d-block">
															29 July 2020 - 02:26 PM
														</small>
													</div>
												</div>
											</li> */}
										</ul>
										<div className="ps__rail-x" style={{ left: 0, bottom: 0 }}>
											<div
												className="ps__thumb-x"
												tabIndex={0}
												style={{ left: 0, width: 0 }}
											/>
										</div>
										<div className="ps__rail-y" style={{ top: 0, right: 0 }}>
											<div
												className="ps__thumb-y"
												tabIndex={0}
												style={{ top: 0, height: 0 }}
											/>
										</div>
									</PerfectScrollbar>
									{/* <Link className="all-notification" to="#">
										See all notifications <i className="ti-arrow-right" />
									</Link> */}
								</Dropdown.Menu>
							</Dropdown>
							{/* <Dropdown as="li" className="nav-item notification_dropdown ">
							<Dropdown.Toggle
							  variant=""
							  className="nav-link bell bell-link i-false"
							  onClick={() => onNote()}
							>
								<svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M20.4604 0.848846H3.31682C2.64742 0.849582 2.00565 1.11583 1.53231 1.58916C1.05897 2.0625 0.792727 2.70427 0.791992 3.37367V15.1562C0.792727 15.8256 1.05897 16.4674 1.53231 16.9407C2.00565 17.414 2.64742 17.6803 3.31682 17.681C3.53999 17.6812 3.75398 17.7699 3.91178 17.9277C4.06958 18.0855 4.15829 18.2995 4.15843 18.5226V20.3168C4.15843 20.6214 4.24112 20.9204 4.39768 21.1817C4.55423 21.4431 4.77879 21.6571 5.04741 21.8008C5.31602 21.9446 5.61861 22.0127 5.92292 21.998C6.22723 21.9833 6.52183 21.8863 6.77533 21.7173L12.6173 17.8224C12.7554 17.7299 12.9179 17.6807 13.0841 17.681H17.187C17.7383 17.68 18.2742 17.4993 18.7136 17.1664C19.1531 16.8334 19.472 16.3664 19.6222 15.8359L22.8965 4.05007C22.9998 3.67478 23.0152 3.28071 22.9413 2.89853C22.8674 2.51634 22.7064 2.15636 22.4707 1.8466C22.2349 1.53684 21.9309 1.28565 21.5822 1.1126C21.2336 0.93954 20.8497 0.849282 20.4604 0.848846ZM21.2732 3.60301L18.0005 15.3847C17.9499 15.5614 17.8432 15.7168 17.6964 15.8274C17.5496 15.938 17.3708 15.9979 17.187 15.9978H13.0841C12.5855 15.9972 12.098 16.1448 11.6836 16.4219L5.84165 20.3168V18.5226C5.84091 17.8532 5.57467 17.2115 5.10133 16.7381C4.62799 16.2648 3.98622 15.9985 3.31682 15.9978C3.09365 15.9977 2.87966 15.909 2.72186 15.7512C2.56406 15.5934 2.47534 15.3794 2.47521 15.1562V3.37367C2.47534 3.15051 2.56406 2.93652 2.72186 2.77871C2.87966 2.62091 3.09365 2.5322 3.31682 2.53206H20.4604C20.5905 2.53239 20.7187 2.56274 20.8352 2.62073C20.9516 2.67872 21.0531 2.7628 21.1318 2.86643C21.2104 2.97005 21.2641 3.09042 21.2886 3.21818C21.3132 3.34594 21.3079 3.47763 21.2732 3.60301Z" fill="#13B499"/>
									<path d="M5.84161 8.42333H10.0497C10.2729 8.42333 10.4869 8.33466 10.6448 8.17683C10.8026 8.019 10.8913 7.80493 10.8913 7.58172C10.8913 7.35851 10.8026 7.14445 10.6448 6.98661C10.4869 6.82878 10.2729 6.74011 10.0497 6.74011H5.84161C5.6184 6.74011 5.40433 6.82878 5.2465 6.98661C5.08867 7.14445 5 7.35851 5 7.58172C5 7.80493 5.08867 8.019 5.2465 8.17683C5.40433 8.33466 5.6184 8.42333 5.84161 8.42333Z" fill="#13B499"/>
									<path d="M13.4161 10.1065H5.84161C5.6184 10.1065 5.40433 10.1952 5.2465 10.353C5.08867 10.5109 5 10.7249 5 10.9481C5 11.1714 5.08867 11.3854 5.2465 11.5433C5.40433 11.7011 5.6184 11.7898 5.84161 11.7898H13.4161C13.6393 11.7898 13.8534 11.7011 14.0112 11.5433C14.169 11.3854 14.2577 11.1714 14.2577 10.9481C14.2577 10.7249 14.169 10.5109 14.0112 10.353C13.8534 10.1952 13.6393 10.1065 13.4161 10.1065Z" fill="#13B499"/>
								</svg>
								<div className="pulse-css"></div>	
							</Dropdown.Toggle>
						</Dropdown> */}
							{/* <Dropdown as="li" className="nav-item dropdown notification_dropdown">
							<Dropdown.Toggle variant="" className="nav-link i-false">
								<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M22.625 5.125H21.75V1.625C21.75 1.47262 21.7102 1.32289 21.6345 1.19062C21.5589 1.05835 21.45 0.948128 21.3186 0.870868C21.1873 0.793609 21.0381 0.751989 20.8857 0.750126C20.7333 0.748264 20.5831 0.786224 20.4499 0.86025L13 4.99909L5.55007 0.86025C5.41688 0.786224 5.26667 0.748264 5.11431 0.750126C4.96194 0.751989 4.8127 0.793609 4.68136 0.870868C4.55002 0.948128 4.44113 1.05835 4.36547 1.19062C4.28981 1.32289 4.25001 1.47262 4.25 1.625V5.125H3.375C2.67904 5.12576 2.01181 5.40257 1.51969 5.89469C1.02757 6.3868 0.750764 7.05404 0.75 7.75V10.375C0.750764 11.071 1.02757 11.7382 1.51969 12.2303C2.01181 12.7224 2.67904 12.9992 3.375 13H4.25V22.625C4.25076 23.321 4.52757 23.9882 5.01969 24.4803C5.51181 24.9724 6.17904 25.2492 6.875 25.25H19.125C19.821 25.2492 20.4882 24.9724 20.9803 24.4803C21.4724 23.9882 21.7492 23.321 21.75 22.625V13H22.625C23.321 12.9992 23.9882 12.7224 24.4803 12.2303C24.9724 11.7382 25.2492 11.071 25.25 10.375V7.75C25.2492 7.05404 24.9724 6.3868 24.4803 5.89469C23.9882 5.40257 23.321 5.12576 22.625 5.125ZM20 5.125H16.3769L20 3.1125V5.125ZM6 3.1125L9.62311 5.125H6V3.1125ZM6 22.625V13H12.125V23.5H6.875C6.64303 23.4997 6.42064 23.4074 6.25661 23.2434C6.09258 23.0793 6.0003 22.857 6 22.625ZM20 22.625C19.9997 22.857 19.9074 23.0793 19.7434 23.2434C19.5794 23.4074 19.35o7 23.4997 19.125 23.5H13.875V13H20V22.625ZM23.5 10.375C23.4997 10.607 23.4074 10.8294 23.2434 10.9934C23.0794 11.1574 22.857 11.2497 22.625 11.25H3.375C3.14303 11.2497 2.92064 11.1574 2.75661 10.9934C2.59258 10.8294 2.5003 10.607 2.5 10.375V7.75C2.5003 7.51803 2.59258 7.29564 2.75661 7.13161C2.92064 6.96758 3.14303 6.8753 3.375 6.875H22.625C22.857 6.8753 23.0794 6.96758 23.2434 7.13161C23.4074 7.29564 23.4997 7.51803 23.5 7.75V10.375Z" fill="#8D98A4"/>
								</svg>
								<div className="pulse-css"></div>
							</Dropdown.Toggle>	
							<Dropdown.Menu align="right" className="mt-2">
								<PerfectScrollbar className="widget-timeline dz-scroll style-1 ps p-3 height370">
									<ul className="timeline">
									  <li>
										<div className="timeline-badge primary" />
										<Link
										  className="timeline-panel c-pointer text-muted"
										  to="#"
										>
										  <span>10 minutes ago</span>
										  <h6 className="mb-0">
											Youtube, a video-sharing website, goes live{" "}
											<strong className="text-primary">$500</strong>.
										  </h6>
										</Link>
									  </li>
									  <li>
										<div className="timeline-badge info"></div>
										<Link
										  className="timeline-panel c-pointer text-muted"
										  to="#"
										>
										  <span>20 minutes ago</span>
										  <h6 className="mb-0">
											New order placed{" "}
											<strong className="text-info">#XF-2356.</strong>
										  </h6>
										  <p className="mb-0">
											Quisque a consequat ante Sit amet magna at
											volutapt...
										  </p>
										</Link>
									  </li>
									  <li>
										<div className="timeline-badge danger"></div>
										<Link
										  className="timeline-panel c-pointer text-muted"
										  to="#"
										>
										  <span>30 minutes ago</span>
										  <h6 className="mb-0">
											john just buy your product{" "}
											<strong className="text-warning">Sell $250</strong>
										  </h6>
										</Link>
									  </li>
									  <li>
										<div className="timeline-badge success"></div>
										<Link
										  className="timeline-panel c-pointer text-muted"
										  to="#"
										>
										  <span>15 minutes ago</span>
										  <h6 className="mb-0">
											StumbleUpon is acquired by eBay.{" "}
										  </h6>
										</Link>
									  </li>
									  <li>
										<div className="timeline-badge warning"></div>
										<Link
										  className="timeline-panel c-pointer text-muted"
										  to="#"
										>
										  <span>20 minutes ago</span>
										  <h6 className="mb-0">
											Mashable, a news website and blog, goes live.
										  </h6>
										</Link>
									  </li>
									  <li>
										<div className="timeline-badge dark"></div>
										<Link
										  className="timeline-panel c-pointer text-muted"
										  to="#"
										>
										  <span>20 minutes ago</span>
										  <h6 className="mb-0">
											Mashable, a news website and blog, goes live.
										  </h6>
										</Link>
									  </li>
									</ul>
									<div className="ps__rail-x" style={{ left: 0, bottom: 0 }}>
									  <div
										className="ps__thumb-x"
										tabIndex={0}
										style={{ left: 0, width: 0 }}
									  />
									</div>
									<div className="ps__rail-y" style={{ top: 0, right: 0 }}>
									  <div
										className="ps__thumb-y"
										tabIndex={0}
										style={{ top: 0, height: 0 }}
									  />
							</div>  */}
							{/* </ul> */}
							{/* </PerfectScrollbar>
							</Dropdown.Menu>
						</Dropdown>  */}
							{/* <Dropdown as="li" className="nav-item notification_dropdown  btn-xs">
							<Dropdown.Toggle
							  variant=""
							  className="nav-link bell bell-link i-false btn-xs"
							  onClick={() => onNote()}
							> 
								<span style={{"width":"40px"}}>{userDetails !=null ?userDetails.name.split(' ')[0][0]:''}{userDetails ?userDetails.name.split(' ')[1][0]:''}</span>
						 	</Dropdown.Toggle>
						</Dropdown> */}
							<Dropdown as="li" className="nav-item header-profile btn-xs  ">
								<Dropdown.Toggle as="a" to="#" variant="" style={{ "height": "40px" }} className="nav-link i-false c-pointer btn-xs">
									{/* <img src={profile} style={{"visiblity":"none"}} width="20" alt=""/> */}
									<div className="header-info">
										{userDetails ? <span>{userDetails.name}<i className="fa fa-caret-down ml-3" aria-hidden="true"></i></span> : ""}
									</div>

								</Dropdown.Toggle>
								<Dropdown.Menu align="right" className="mt-2">
									{/* <Link to="/app-profile" className="dropdown-item ai-icon">
								<svg
								  id="icon-user1"
								  xmlns="http://www.w3.org/2000/svg"
								  className="text-primary"
								  width={18}
								  height={18}
								  viewBox="0 0 24 24"
								  fill="none"
								  stroke="currentColor"
								  strokeWidth={2}
								  strokeLinecap="round"
								  strokeLinejoin="round"
								>
								  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
								  <circle cx={12} cy={7} r={4} />
								</svg>
							  </Link> */}
									<Profile />
									{/* <Link to="/PAG/sendMail" className="dropdown-item ai-icon">
								<svg
								  id="icon-inbox"
								  xmlns="http://www.w3.org/2000/svg"
								  className="text-success"
								  width={18}
								  height={18}
								  viewBox="0 0 24 24"
								  fill="none"
								  stroke="currentColor"
								  strokeWidth={2}
								  strokeLinecap="round"
								  strokeLinejoin="round"
								>
								  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
								  <polyline points="22,6 12,13 2,6" />
								</svg>
								<span className="ml-2">Send Mail</span>
							  </Link> */}
									<ChangePassword />
									<LogoutPage />
								</Dropdown.Menu>
							</Dropdown>
						</ul>
						{/* </PerfectScrollbar>
					</Dropdown.Menu>
					</Dropdown>
					</ul> */}

					</div>
				</nav>
			</div>
		</div>
	);
};

export default Header;
